/**
 * Sentry instrumentation for the web app. Initialized before the first
 * React render so component errors land in the dashboard.
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN_WEB as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export { Sentry };
export const sentryEnabled = Boolean(dsn);
